/**
 * Copy text to the clipboard.
 *
 * `navigator.clipboard` is only available on a secure origin, and the CRM is
 * reached over plain http on the LAN often enough that the textarea fallback is
 * the path that actually runs there.
 */
export const copyText = async (text) => {
  const value = text == null ? "" : String(text);
  if (!value) return false;

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch (err) {
    // Fall through to the textarea below.
  }

  try {
    const textArea = document.createElement("textarea");
    textArea.value = value;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(textArea);
    return copied;
  } catch (err) {
    return false;
  }
};

/** Digits only, the shape wa.me links and WhatsApp's API both want. */
export const waDigits = (number) => String(number || "").replace(/\D/g, "");

/** The wa.me link for a number, or null when there is nothing dialable. */
export const waLink = (number) => {
  const digits = waDigits(number);
  return digits ? `https://wa.me/${digits}` : null;
};
